module.exports = __webpack_public_path__ + "img/tech.fdd49cd2.svg";